export default function EmptyList({ message = "This list is empty" }) {
  return <div className="flex justify-center my-8 px-3">{message}</div>;
}
